import { dashboardService } from "@/api/services/dashboardService";
import { DashboardApiMetricWidget } from "../dashboardLeafWidgets";

type Data = Record<string, any>;

/** 新增会员用户统计，保留旧版三类会员数量。 */
export default function AddMemberCustomerStatistic() {
    return (
        <DashboardApiMetricWidget<Data>
            title="会员用户新增统计"
            load={value => dashboardService.getAddMemberCustomerStatistic(value as never)}
            metrics={[
                { label: "新增基础会员", key: "addBaseMemberNum", unit: "人" },
                { label: "新增高级会员", key: "addSeniorMemberNum", unit: "人" },
                { label: "新增企业会员", key: "addEnterpriseGradeMemberNum", unit: "人" }
            ]}
            options={["month", "quarter", "year"]}
            defaultActive="month"
        />
    );
}
